import { render, staticRenderFns } from "./welcome_page.vue?vue&type=template&id=65478ce9"
import script from "./welcome_page.vue?vue&type=script&lang=js"
export * from "./welcome_page.vue?vue&type=script&lang=js"
import style0 from "./welcome_page.vue?vue&type=style&index=0&id=65478ce9&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports